import fetch from "../../../core/fetch";
import showToaster from "../../../helpers/showToaster";
import {
  inputTextLimit,
  containsMalicious,
} from "../../../helpers/textRestriction";

async function submit(values, dispatch) {
  const { id, title, content } = values;

  if (containsMalicious(title) || containsMalicious(content)) {
    showToaster({ messageId: "invalidInput", toasterType: "error" });
    return;
  }

  const query = `
    query (
      $id: Int,
      $title: String,
      $content: String
    ) {
      updateBannerSettings (
        id: $id,
        title: $title,
        content: $content
      ) {
        status
      }
    }
  `;

  const resp = await fetch("/graphql", {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      query: query,
      variables: { id, title, content },
    }),
    credentials: "include",
  });

  const { data } = await resp.json();
  const result = data?.updateBannerSettings?.status;

  showToaster({
    messageId: result === "success" ? "bannerSetting" : "bannerSettingError",
    toasterType: result === "success" ? "success" : "error",
  });
}

export default submit;
